import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { SvgIconComponent } from '~/shared/form-elements/components/svg-icon/svg-icon.component';

enum MobileDownloadSegmentEnum {
  ANDROID = 'ANDROID',
  IOS = 'IOS'
}

@Component({
  selector: 'qvs-login-mobile-download',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslatePipe, FormsModule, SvgIconComponent],
  templateUrl: './login-mobile-download.component.html',
  styleUrls: ['./login-mobile-download.component.scss']
})
export class LoginMobileDownloadComponent {
  readonly assets = {
    icons: {
      access: 'assets/icons/access_app.svg',
      banking: 'assets/icons/qvs_banking_app.svg'
    },
    qrCodes: {
      ios: {
        access: 'assets/appstore_access_qr_code.png',
        banking: 'assets/appstore-mobile-qr-code.png'
      },
      android: {
        access: 'assets/playstore-access-qr-code.png',
        banking: 'assets/playstore-mobile-qr-code.png'
      }
    },
    storeLogos: {
      ios: 'assets/download_on_appstore.svg',
      android: 'assets/download_on_google_play_store.svg'
    },
    storeLinks: {
      ios: {
        access: 'https://apps.apple.com/ch/app/qvs-access-secure-login/id1506596364',
        banking: 'https://apps.apple.com/ch/app/qvs-mobile-banking/id1530038368'
      },
      android: {
        access: 'https://play.google.com/store/apps/details?id=ch.quilvest.accessapp&hl=en',
        banking: 'https://play.google.com/store/apps/details?id=ch.quilvest.bankingapp&hl=en'
      }
    }
  } as const;

  segment = MobileDownloadSegmentEnum;
  selectedSegment = MobileDownloadSegmentEnum.IOS;
}
